import { CastingBase } from "../json-schemas/base/casting"
import { OfferedServiceBase } from "../json-schemas/base/offered_service"
import { ServiceDeliveryBase } from "../json-schemas/base/service_delivery"
import { Currency } from "./currency.service"

export function trackingOnSignup () {
  if (window.gtag) window.gtag('event', 'sign_up', { method: 'Email/Password' })
  if (window.fbq) window.fbq('track', 'CompleteRegistration')
}

export function trackingOnLogin () {
  if (window.gtag) window.gtag('event', 'login', { method: 'Email/Password' })
}

export function trackingCastingWidgetSubmitted () {
  if (window.fbq) window.fbq('track', 'SubmitApplication')
}

interface OnCastingCreate {
  casting: Pick<CastingBase, 'slots' | 'quantity' | 'casting_type'>
  offeredService: Pick<OfferedServiceBase, 'id' | 'name' | 'offered_service_type' | 'rentable_unit_of_work'>
  currency: Currency
  priceCents: number
}

export function trackingOnCastingCreate ({ casting, currency, priceCents, offeredService }: OnCastingCreate) {
  const value = (priceCents || 0) / 100
  const quantity = offeredService.offered_service_type === 'product'
    ? casting.quantity
    : offeredService.rentable_unit_of_work === 'hour' && casting.slots.length && casting.slots.every(_ => _.duration)
    ? +(casting.slots.reduce((acc, _) => acc + _.duration, 0) / 3600).toFixed(2)
    : 1

  if (window.gtag) {
    window.gtag('event', 'generate_lead', { currency, value, casting_type: casting.casting_type, service_name: offeredService.name })
  }

  if (window.fbq) {
    // content is required for Ad Advantage+ program (https://developers.facebook.com/docs/meta-pixel/reference/)
    window.fbq('track', 'AddToCart', { contents: [{ id: offeredService.id, quantity }], currency, value })
  }
}

export function trackingOnServiceDeliveryPaymentInfoSet () {
  if (window.fbq) window.fbq('track', 'AddPaymentInfo')
}

interface OnServiceDeliveryConfirmed {
  serviceDeliveryId: ServiceDeliveryBase['id']
  offeredService: Pick<OfferedServiceBase, 'id'>
  castingType: CastingBase['casting_type']
  currency: Currency
  priceCents: number
  taxCents: number
}

export function trackingOnServiceDeliveryConfirmed ({ castingType, currency, serviceDeliveryId, priceCents, taxCents, offeredService }: OnServiceDeliveryConfirmed) {
  if (window.gtag) {
    window.gtag('event', 'purchase', { casting_type: castingType, currency, value: (priceCents || 0) / 100, tax: (taxCents || 0) / 100, transaction_id: serviceDeliveryId })
  }

  if (window.fbq) {
    // value, currency, content_ids are required for Ad Advantage+ program (https://developers.facebook.com/docs/meta-pixel/reference/)
    window.fbq('track', 'Purchase', { value: (priceCents || 0) / 100, currency, content_ids: [offeredService.id] })
  }
}
